<ac-combined-data-table
	*ngIf="isValidTableData; else noData"
	[tabs]="tabs"
	[isBordered]="true"
	[isStriped]="true"
	[isPadded]="true"
	[excludeColumns]="excludeColumns"
	[columnWidths]="columnWidths"
	[tableIndex]="tableIndex"
></ac-combined-data-table>

<ng-template #noData>
	<div class="margin-vertical-45">
		<span dcrHTMLKey="NO_RANKINGS_DATA_DISCLOSURE">Rankings data is unavailable</span>
	</div>
</ng-template>
